import React, { useContext } from "react"

import { Collapse } from 'reactstrap'

import classnames from "classnames";

import { ScenarioContext } from "../contexts/ScenarioContext";

import CheckListItem from "./CheckListItem"
import ChevronIcon from "./icons/ChevronIcon"

const isHeading = (step) => step.type === "heading"

export default function CheckList({ steps, depth = 4, first = false}){
  const { toggleCollapsed, getCollapsed } = useContext(ScenarioContext)

  return (
    <ul className={classnames({ first: first })}>
      {steps.map((step) => (
        <li key={`li-${step.id}`}>
          {!isHeading(step)
            ?
            <CheckListItem step={step} />
            :
            <>
              <p
                style={{ cursor: "pointer" }}
                className={`h${depth}`}
                onClick={() => toggleCollapsed(step.id)}
              >
                {step.label}
                <ChevronIcon expand={getCollapsed(step.id)} />
              </p>

              <Collapse isOpen={getCollapsed(step.id)}>
                <CheckList
                  steps={step.children}
                  depth={depth + 1}
                />
              </Collapse>
            </>
          }
        </li>
      )
      )}
    </ul>
  )

}
